'use strict';
module.exports = require('./CascadeSelect.vue');